import { render, staticRenderFns } from "./LayoutSettings.vue?vue&type=template&id=b29d8f68&scoped=true"
import script from "./LayoutSettings.vue?vue&type=script&lang=js"
export * from "./LayoutSettings.vue?vue&type=script&lang=js"
import style0 from "./LayoutSettings.vue?vue&type=style&index=0&id=b29d8f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29d8f68",
  null
  
)

export default component.exports